import { render, staticRenderFns } from "./Tallas.vue?vue&type=template&id=1d5a0a72"
import script from "./Tallas.vue?vue&type=script&lang=js"
export * from "./Tallas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports